
import { Vue, Component, Prop } from 'vue-property-decorator';
import TimelineSummaryContainer from '@/components/DataTab/Charts/ChartComponents/TimelineSummaryCharts/TimelineSummaryContainer.vue';
import { axios } from '@/helpers/axios';
import { AxiosResponse } from 'axios';
import {
  ChartLoadingStatus,
  SummaryFormattedType,
  AnnualAgDemSummaryType,
  TimelineFormattedType,
  AnnualAgDemTimelineType,
} from '@/types';

@Component({
  components: { TimelineSummaryContainer },
})
export default class Plot117 extends Vue {
  @Prop() readonly areaId!: number;

  mounted() {
    this.lineDataStatus = 'loading';
    this.summaryDataStatus = 'loading';
    axios
      .get(`/charts/17/${this.areaId}`)
      .then((response: AxiosResponse) => {
        this.lineData = response.data.data;
        this.lineDataStatus = 'success';
      })
      .catch(() => (this.lineDataStatus = 'error'));

    axios
      .get(`/charts/18/${this.areaId}`)
      .then((response: AxiosResponse) => {
        this.summaryData = response.data.data;
        this.summaryDataStatus = 'success';
      })
      .catch(() => (this.summaryDataStatus = 'error'));
  }

  lineData: AnnualAgDemTimelineType[] = [];
  lineDataStatus: ChartLoadingStatus = 'idle';

  summaryData: AnnualAgDemSummaryType[] = [];
  summaryDataStatus: ChartLoadingStatus = 'idle';

  get formattedLineData(): TimelineFormattedType[] {
    let formatted: TimelineFormattedType[] = [];
    this.lineData.forEach(item =>
      formatted.push({
        scenario: item.scenario,
        date: item.year,
        value: item.ag_gemand,
      }),
    );

    return formatted;
  }

  get formattedSummaryData(): SummaryFormattedType[] {
    let formatted: SummaryFormattedType[] = [];
    this.summaryData.forEach(item =>
      formatted.push({
        scenario: item.scenario,
        max: item.ag_demand_max,
        q3: item.ag_demand_75,
        median: item.ag_demand_median,
        q1: item.ag_demand_25,
        min: item.ag_demand_min,
      }),
    );
    return formatted;
  }
}
